import i18n from "i18next";
import { initReactI18next } from "react-i18next";

//Language : German (Json Files)
import AccessCourseDE from "./locales/de/AccessCourse_de.json";
import AdminHeaderDE from "./locales/de/AdminHeader_de.json";
import AssignCourseModalDE from "./locales/de/AssignCourseModal_de.json";
import BusinessAnalyticsDE from "./locales/de/BusinessAnalytics_de.json";
import BusinessBookmarksDE from "./locales/de/BusinessBookmarks_de.json";
import BusinessComplianceDE from "./locales/de/BusinessCompliance_de.json";
import BusinessCoursesDE from "./locales/de/BusinessCourses_de.json";
import BusinessDashbaordHomeDE from "./locales/de/BusinessDashbaordHome_de.json";
import BusinessFamilyDE from "./locales/de/BusinessFamily_de.json";
import BusinessGroupViewDE from "./locales/de/BusinessGroupView_de.json";
import BusinessLandingPageDE from "./locales/de/BusinessLandingPage_de.json";
import BusinessLeaderboardDE from "./locales/de/BusinessLeaderboard_de.json";
import BusinessLearningGroupsDE from "./locales/de/BusinessLearningGroups_de.json";
import BusinessPaymentDE from "./locales/de/BusinessPayment_de.json";
import BusinessProgressDE from "./locales/de/BusinessProgress_de.json";
import BusinessQuizzesDE from "./locales/de/BusinessQuizzes_de.json";
import BusinessSettingDE from "./locales/de/BusinessSettings_de.json";
import BusinessSidebarDE from "./locales/de/BusinessSidebar_de.json";
import BusinessSubscriptionDE from "./locales/de/BusinessSubscription_de.json";
import BusinessUserDetailsDE from "./locales/de/BusinessUserDetails_de.json";
import CategoriesCardDE from "./locales/de/CategoriesCard_de.json";
import ChangePasswordDE from "./locales/de/ChangePassword_de.json";
import CommunityAnnouncementsDE from "./locales/de/CommunityAnnouncements_de.json";
import CommunityHelpDE from "./locales/de/CommunityHelp_de.json";
import CommunityHelpCenterTopicDE from "./locales/de/CommunityHelpCenterTopic_de.json";
import CommunityHomeBannerDE from "./locales/de/CommunityHomeBanner_de.json";
import CommunitySecDE from "./locales/de/CommunitySec_de.json";
import CommunitySidbarDE from "./locales/de/CommunitySidbar_de.json";
import CommunitySidbarModalDE from "./locales/de/CommunitySidbarModal_de.json";
import ComparisonTableDE from "./locales/de/ComparisonTable_de.json";
import CompleteDE from "./locales/de/Complete_de.json";
import Complete2DE from "./locales/de/Complete2_de.json";
import ContentCoursesDE from "./locales/de/ContentCourses_de.json";
import ContentHomeDE from "./locales/de/ContentHome_de.json";
import ContentMultifileQuizzesDE from "./locales/de/ContentMultifileQuizzes_de.json";
import ContentPreviewDE from "./locales/de/ContentPreview_de.json";
import ContentQuestionsDE from "./locales/de/ContentQuestions_de.json";
import ContentQuizzesDE from "./locales/de/ContentQuizzes_de.json";
import ContentSidbarDE from "./locales/de/ContentSidbar_de.json";
import ContentUploadDE from "./locales/de/ContentUpload_de.json";
import CourseCardDE from "./locales/de/CourseCard_de.json";
import CourseCardCompornantDE from "./locales/de/CourseCardCompornant_de.json";
import CourseDetailsDE from "./locales/de/CourseDetails_de.json";
import CourseListDE from "./locales/de/CourseList_de.json";
import CourseMandatoryDE from "./locales/de/CourseMandatory_de.json";
import CoursesExploreDE from "./locales/de/CoursesExplore_de.json";
import CoursesHomeSecDE from "./locales/de/CoursesHomeSec_de.json";
import CourseSidebarDE from "./locales/de/CourseSidebar_de.json";
import CoursesVoluntaryDE from "./locales/de/CoursesVoluntary_de.json";
import CustomerBookmarksDE from "./locales/de/CustomerBookmarks_de.json";
import CustomerCoursesDE from "./locales/de/CustomerCourses_de.json";
import CustomerHomeDE from "./locales/de/CustomerHome_de.json";
import CustomerHomeExploreDE from "./locales/de/CustomerHomeExplore_de.json";
import CustomerLeaderboardDE from "./locales/de/CustomerLeaderboard_de.json";
import CustomerMyProgressDE from "./locales/de/CustomerMyProgress_de.json";
import CustomerQuizzesDE from "./locales/de/CustomerQuizzes_de.json";
import CustomerSidbarDE from "./locales/de/CustomerSidbar_de.json";
import EditProfileDE from "./locales/de/EditProfile_de.json";
import EmployeeProfileDE from "./locales/de/EmployeeProfile_de.json";
import EmployeeReportDE from "./locales/de/EmployeeReport_de.json";
import EmployeesProgressDE from "./locales/de/EmployeesProgress_de.json";
import FamilyDE from "./locales/de/Family_de.json";
import FaqDE from "./locales/de/Faq_de.json";
import FaqQuestionsDE from "./locales/de/FaqQuestions_de.json";
import FeaturedDetailsDE from "./locales/de/FeaturedDetails_de.json";
import FeaturedQuize1DE from "./locales/de/FeaturedQuize1_de.json";
import FeaturedQuize2DE from "./locales/de/FeaturedQuize2_de.json";
import FeedbackDE from "./locales/de/Feedback_de.json";
import FileDropDE from "./locales/de/FileDrop_de.json";
import FooterDE from "./locales/de/Footer_de.json";
import HeaderDE from "./locales/de/Header_de.json";
import indexDE from "./locales/de/index_de.json";
import IndividualPricingDE from "./locales/de/IndividualPricing_de.json";
import KnowledgeHubCategoriesDE from "./locales/de/KnowledgeHubCategories_de.json";
import MyTeamDE from "./locales/de/MyTeam_de.json";
import OnlyMeDE from "./locales/de/OnlyMe_de.json";
import PaymentDE from "./locales/de/Payment_de.json";
import QuizeResultsDE from "./locales/de/QuizeResults_de.json";
import Section1DE from "./locales/de/Section1_de.json";
import Section2DE from "./locales/de/Section2_de.json";
import SignInDE from "./locales/de/SignIn_de.json";
import SignUpDE from "./locales/de/SignUp_de.json";
import SliderHomeSecDE from "./locales/de/SliderHomeSec_de.json";
import StudentTestimonialsDE from "./locales/de/StudentTestimonials_de.json";
import SubscriptionDE from "./locales/de/Subscription_de.json";
import TeamsDE from "./locales/de/Teams_de.json";
import TopPerformersDE from "./locales/de/TopPerformers_de.json";
import UpdateAssociatedCodeDE from "./locales/de/UpdateAssociatedCode_de.json";
import CourseLevelDE from "./locales/de/CourseLevel_de.json";
import GoldCoursesDE from "./locales/de/GoldCourses_de.json";
import GoldCoursesHomeDE from "./locales/de/GoldCoursesHome_de.json";
import SidbarCoursesDE from "./locales/de/SidbarCourses_de.json";
import CompilanceDE from "./locales/de/Compilance_de.json";
import CeoManagerDE from "./locales/de/CeoManager_de.json";
import ComplianceOfficerDE from "./locales/de/ComplianceOfficer_de.json";
import DposDE from "./locales/de/Dpos_de.json";
import EmployeDE from "./locales/de/Employe_de.json";
import SriLankaCourseDE from "./locales/de/SriLankaCourse_de.json";
import SrilLankaCourseQuize1DE from "./locales/de/SrilLankaCourseQuize1_de.json";
import SrilLankaCourseQuize2DE from "./locales/de/SrilLankaCourseQuize2_de.json";
import FeaturedGoldCourseDE from "./locales/de/FeaturedGoldCourse_de.json";
import FeaturedGoldCourseDetailsDE from "./locales/de/FeaturedGoldCourseDetails_de.json";
import AssignCourseDE from "./locales/de/AssignCourse_de.json";
import BulkUploadDE from "./locales/de/BulkUpload_de.json";
import BusinessUserBlendedLearningDE from "./locales/de/BusinessUserBlendedLearning_de.json";
import BusinessUserCourseTrailDE from "./locales/de/BusinessUserCourseTrail_de.json";
import BusinessUserIndividualizedCoursesDE from "./locales/de/BusinessUserIndividualizedCourses_de.json";
import BusinessUserPaymentDE from "./locales/de/BusinessUserPayment_de.json";
import BusinessUserPlansDE from "./locales/de/BusinessUserPlans_de.json";
import BusinessUserSharedCoursesDE from "./locales/de/BusinessUserSharedCourses_de.json"; //
import BusinessUserSupportPlansDE from "./locales/de/BusinessUserSupportPlans_de.json";
import FeaturedGoldCourseQuize1DE from "./locales/de/FeaturedGoldCourseQuize1_de.json";
import FeaturedGoldCourseQuize2DE from "./locales/de/FeaturedGoldCourseQuize2_de.json";
import ImportDE from "./locales/de/Import_de.json";
import ImprintDE from "./locales/de/Imprint_de.json";
import KidsAgeConfirmDE from "./locales/de/KidsAgeConfirm_de.json";
import OtpDE from "./locales/de/Otp_de.json";
import ParentApprovalDE from "./locales/de/ParentApproval_de.json";
import ParentDetailDE from "./locales/de/ParentDetails_de.json";
import PaymentDetailsDE from "./locales/de/PaymentDetails_de.json";
import PreviewTableDE from "./locales/de/PreviewTable_de.json";
import RejectKidDE from "./locales/de/RejectKid_de.json";
import SelectCourseDE from "./locales/de/SelectCourse_de.json";
import SetCourseDE from "./locales/de/SetCourse_de.json";
import TermsAndConditionDE from "./locales/de/TermsAndCondition_de.json";
import TestEnvironmentWelcomeDE from "./locales/de/TestEnvironmentWelcome_de.json";
import UploadFileDE from "./locales/de/UploadFile_de.json";
import InformationSecurityDE from "./locales/de/InformationSecurity_de.json";
import PointsHeaderDE from "./locales/de/PointsHeader_de.json";
import ReportanIssueDE from "./locales/de/ReportanIssue_de.json";
import RequestLegalAdviceDE from "./locales/de/RequestLegalAdvice_de.json";
import RequestLegalAdviceFormDE from "./locales/de/RequestLegalAdviceForm_de.json";
import RequestOnlineTrainingDE from "./locales/de/RequestOnlineTraining_de.json";
import RequestTrainingDE from "./locales/de/RequestTraining_de.json";
import ResponsibleAIDE from "./locales/de/ResponsibleAI_de.json";
import ShareYourFeedbackDE from "./locales/de/ShareYourFeedback_de.json";
import StripeRedirectDE from "./locales/de/StripeRedirect_de.json";
import SuggestFutureTrainingTopicsDE from "./locales/de/SuggestFutureTrainingTopics_de.json";
import TrailsDE from "./locales/de/Trails_de.json";
import TransferJobDE from "./locales/de/TransferJob_de.json";
import WhatDidYouLearnDE from "./locales/de/WhatDidYouLearn_de.json";
import WhatsOpenAiDE from "./locales/de/WhatsOpenAi_de.json";
import BusinessCaseStudiesResultsDE from "./locales/de/BusinessCaseStudiesResults_de.json";
import BusinessCaseStudyQuestionDE from "./locales/de/BusinessCaseStudyQuestion_de.json";
import BusinessCourseDE from "./locales/de/BusinessCourse_de.json";
import BusinessCourseQuizDE from "./locales/de/BusinessCourseQuiz_de.json";
import BusinessCourseResultsDE from "./locales/de/BusinessCourseResults_de.json";
import BusinessDataPrivacyTrailDE from "./locales/de/BusinessDataPrivacyTrail_de.json";
import BusinessDataPrivacyTrailResultsDE from "./locales/de/BusinessDataPrivacyTrailResults_de.json";
import BusinessFactsDE from "./locales/de/BusinessFacts_de.json";
import BusinessFactsDetailsDE from "./locales/de/BusinessFactsDetails_de.json";
import SelectSubscriptionDE from "./locales/de/SelectSubscription_de.json";
import BusinessPointsDE from "./locales/de/BusinessPoints_de.json";
import BusinessPublicSpacesDE from "./locales/de/BusinessPublicSpaces_de.json";
import BusinessPuzzleDE from "./locales/de/BusinessPuzzle_de.json";
import BusinessQuizDE from "./locales/de/BusinessQuiz_de.json";
import BusinessQuizChooseGuideDE from "./locales/de/BusinessQuizChooseGuide_de.json";
import BusinessQuizResultsDE from "./locales/de/BusinessQuizResults_de.json";
import BusinessQuizStartDE from "./locales/de/BusinessQuizStart_de.json";
import BusinessUnansweredQuestionsDE from "./locales/de/BusinessUnansweredQuestions_de.json";
import CertificateDE from "./locales/de/Certificate_de.json";
import ComplianceReportingDashboardDE from "./locales/de/ComplianceReportingDashboard_de.json";
import DataPrivacyDE from "./locales/de/DataPrivacy_de.json";
import FamilyUserBlendedLearningDE from "./locales/de/FamilyUserBlendedLearning_de.json";
import FamilyUserPaymentDetailsDE from "./locales/de/FamilyUserPaymentDetails_de.json";
import PaymentProcessedDE from "./locales/de/PaymentProcessed_de.json";
import FamilyUserPlansDE from "./locales/de/FamilyUserPlans_de.json";
import QuizResultDE from "./locales/de/QuizeResults_de.json";
import AreaChartDE from "./locales/de/AreaChart_de.json";
import SweetAlertDE from "./locales/de/SweetAlert_de.json";
import DragAndDropDE from "./locales/de/DragAndDrop_de.json";
import validateForSignInDE from "./locales/de/Validate_de.json";
import commonDE from "./locales/de/common_de.json";
import AIDashboardDE from "./locales/de/AIDashboard_de.json";
import AITrailDE from "./locales/de/AITrail_de.json";
import AIShareYourFeedbackDE from "./locales/de/AIShareYourFeedback_de.json";
import AdvantagesDE from "./locales/de/Advantages_de.json";
import AIUserPlansDE from "./locales/de/AIUserPlans_de.json";

//Language : English (Json Files)
import courseDetailsEN from "./locales/en/CourseDetails.json";
import BusinessLandingPageEN from "./locales/en/BusinessLandingPage.json";
import BussinessDashboardHomeEN from "./locales/en/BusinessDashbaordHome.json";
import indexMainpageEN from "./locales/en/index.json";
import OnlyMePageEN from "./locales/en/OnlyMe.json";
import MyTeamPageEN from "./locales/en/MyTeam.json";
import StudentTestimonialsEN from "./locales/en/StudentTestimonials.json";
import headerEN from "./locales/en/Header.json";
import knowledgehubcategoriesEN from "./locales/en/KnowledgeHubCategories.json";
import accessCourseEN from "./locales/en/AccessCourse.json";
import faqEN from "./locales/en/Faq.json";
import footerEN from "./locales/en/Footer.json";
import courseListEN from "./locales/en/CourseList.json";
import individualPricingEN from "./locales/en/IndividualPricing.json";
import teamsEN from "./locales/en/Teams.json";
import CategoriesCardEN from "./locales/en/CategoriesCard.json";
import ComparisonTableEN from "./locales/en/ComparisonTable.json";
import CommunityAnnouncementsEN from "./locales/en/CommunityAnnouncements.json";
import CommunityHomeBannerEN from "./locales/en/CommunityHomeBanner.json";
import CommunitySidbarEN from "./locales/en/CommunitySidbar.json";
import CommunitySidbarModalEN from "./locales/en/CommunitySidbarModal.json";
import FaqQuestionsEN from "./locales/en/FaqQuestions.json";
import FeaturedDetailsEN from "./locales/en/FeaturedDetails.json";
import CourseSidebarEN from "./locales/en/CourseSidebar.json";
import FeaturedQuize1EN from "./locales/en/FeaturedQuize1.json";
import FeaturedQuize2EN from "./locales/en/FeaturedQuize2.json";
import FeedbackEN from "./locales/en/Feedback.json";
import QuizResultEN from "./locales/en/QuizeResults.json";
import SignupEN from "./locales/en/SignUp.json";
import SigninEN from "./locales/en/SignIn.json";
import BusinessOwnerDetailsEN from "./locales/en/BusinessUserDetails.json";
import BusinessUserDetailsEN from "./locales/en/BusinessUserDetails.json";
import BusinessSubscriptionEN from "./locales/en/BusinessSubscription.json";
import BusinessPaymentEN from "./locales/en/BusinessPayment.json";
import CompleteEN from "./locales/en/Complete.json";
import Complete2EN from "./locales/en/Complete2.json";
import SubscriptionEN from "./locales/en/Subscription.json";
import SelectSubscriptionEN from "./locales/en/SelectSubscription.json";
import PaymentProcessedEN from "./locales/en/PaymentProcessed.json";
import PaymentEN from "./locales/en/Payment.json";
import CommunityHelpEN from "./locales/en/CommunityHelp.json";
import CommunityHelpCenterTopicEN from "./locales/en/CommunityHelpCenterTopic.json";
import BussinessProgressEN from "./locales/en/BusinessProgress.json";
import AdminHeaderEN from "./locales/en/AdminHeader.json";
import BusinessSidebarEN from "./locales/en/BusinessSidebar.json";
import BusinessBookmarksEN from "./locales/en/BusinessBookmarks.json";
import CourseCardCompornantEN from "./locales/en/CourseCardCompornant.json";
import BusinessLeaderboardEN from "./locales/en/BusinessLeaderboard.json";
import TopPerformersEN from "./locales/en/TopPerformers.json";
import BusinessCoursesEN from "./locales/en/BusinessCourses.json";
import BusinessQuizzesEN from "./locales/en/BusinessQuizzes.json";
import BusinessLearningGroupsEN from "./locales/en/BusinessLearningGroups.json";
import BusinessGroupViewEN from "./locales/en/BusinessGroupView.json";
import BusinessAnalyticsEN from "./locales/en/BusinessAnalytics.json";
import BusinessSettingsEN from "./locales/en/BusinessSettings.json";
import BusinessComplianceEN from "./locales/en/BusinessCompliance.json";
import EmployeeProfileEN from "./locales/en/EmployeeProfile.json";
import Section1EN from "./locales/en/Section1.json";
import Section2EN from "./locales/en/Section2.json";
import CourseMandatoryEN from "./locales/en/CourseMandatory.json";
import CoursesVoluntaryEN from "./locales/en/CoursesVoluntary.json";
import EmployeesProgressEN from "./locales/en/EmployeesProgress.json";
import EmployeeReportEN from "./locales/en/EmployeeReport.json";
import BusinessFamilyEN from "./locales/en/BusinessFamily.json";
import CustomerSidbarEN from "./locales/en/CustomerSidbar.json";
import SliderHomeSecEN from "./locales/en/SliderHomeSec.json";
import FamilyEN from "./locales/en/Family.json";
import ChangePasswordEN from "./locales/en/ChangePassword.json";
import EditProfileEN from "./locales/en/EditProfile.json";
import UpdateAssociatedCodeEN from "./locales/en/UpdateAssociatedCode.json";
import CustomerHomeEN from "./locales/en/CustomerHome.json";
import CustomerHomeExploreEN from "./locales/en/CustomerHomeExplore.json";
import CustomerMyProgressEN from "./locales/en/CustomerMyProgress.json";
import CustomerBookmarksEN from "./locales/en/CustomerBookmarks.json";
import CustomerLeaderboardEN from "./locales/en/CustomerLeaderboard.json";
import CustomerCoursesEN from "./locales/en/CustomerCourses.json";
import AssignCourseModalEN from "./locales/en/AssignCourseModal.json";
import CustomerQuizzesEN from "./locales/en/CustomerQuizzes.json";
import ContentHomeEN from "./locales/en/ContentHome.json";
import ContentSidbarEN from "./locales/en/ContentSidbar.json";
import ContentUploadEN from "./locales/en/ContentUpload.json";
import FileDropEN from "./locales/en/FileDrop.json";
import ContentPreviewEN from "./locales/en/ContentPreview.json";
import ContentQuestionsEN from "./locales/en/ContentQuestions.json";
import ContentMultifileQuizzesEN from "./locales/en/ContentMultifileQuizzes.json";
import ContentCoursesEN from "./locales/en/ContentCourses.json";
import ContentQuizzesEN from "./locales/en/ContentQuizzes.json";
import CoursesExploreEN from "./locales/en/CoursesExplore.json";
import CoursesHomeSecEN from "./locales/en/CoursesHomeSec.json";
import CourseCardEN from "./locales/en/CourseCard.json";
import CommunitySecEN from "./locales/en/CommunitySec.json";
import CourseLevelEN from "./locales/en/CourseLevel.json";
import GoldCoursesEN from "./locales/en/GoldCourses.json";
import GoldCoursesHomeEN from "./locales/en/GoldCoursesHome.json";
import SidbarCoursesEN from "./locales/en/SidbarCourses.json";
import CompilanceEN from "./locales/en/Compilance.json";
import CeoManagerEN from "./locales/en/CeoManager.json";
import ComplianceOfficerEN from "./locales/en/ComplianceOfficer.json";
import DposEN from "./locales/en/Dpos.json";
import EmployeEN from "./locales/en/Employe.json";
import SriLankaCourseEN from "./locales/en/SriLankaCourse.json";
import CourseDetailsEN from "./locales/en/CourseDetails.json";
import SrilLankaCourseQuize1EN from "./locales/en/SrilLankaCourseQuize1.json";
import SrilLankaCourseQuize2EN from "./locales/en/SrilLankaCourseQuize2.json";
import FeaturedGoldCourseEN from "./locales/en/FeaturedGoldCourse.json";
import FeaturedGoldCourseDetailsEN from "./locales/en/FeaturedGoldCourseDetails.json";
import FeaturedGoldCourseQuize1EN from "./locales/en/FeaturedGoldCourseQuize1.json";
import FeaturedGoldCourseQuize2EN from "./locales/en/FeaturedGoldCourseQuize2.json";
import BulkUploadEN from "./locales/en/BulkUpload.json";
import UploadFileEN from "./locales/en/UploadFile.json";
import PreviewTableEN from "./locales/en/PreviewTable.json";
import ImportEN from "./locales/en/Import.json";
import AssignCourseEN from "./locales/en/AssignCourse.json";
import SelectCourseEN from "./locales/en/SelectCourse.json";
import SetCourseEN from "./locales/en/SetCourse.json";
import OtpEN from "./locales/en/Otp.json";
import KidsAgeConfirmEN from "./locales/en/KidsAgeConfirm.json";
import ParentDetailEN from "./locales/en/ParentDetails.json";
import ParentApprovalEN from "./locales/en/ParentApproval.json";
import RejectKidEN from "./locales/en/RejectKid.json";
import ImprintEN from "./locales/en/Imprint.json";
import TermsAndConditionEN from "./locales/en/TermsAndCondition.json";
import TestEnvironmentWelcomeEN from "./locales/en/TestEnvironmentWelcome.json";
import BusinessUserPlansEN from "./locales/en/BusinessUserPlans.json";
import BusinessUserSupportPlansEN from "./locales/en/BusinessUserSupportPlans.json";
import BusinessUserSharedCoursesEN from "./locales/en/BusinessUserSharedCourses.json";
import BusinessUserPaymentEN from "./locales/en/BusinessUserPayment.json";
import BusinessSettingEN from "./locales/en/BusinessSetting.json";
import BusinessUserCourseTrailEN from "./locales/en/BusinessUserCourseTrail.json";
import BusinessUserIndividualizedCoursesEN from "./locales/en/BusinessUserIndividualizedCourses.json";
import BusinessUserBlendedLearningEN from "./locales/en/BusinessUserBlendedLearning.json";
import PaymentDetailsEN from "./locales/en/PaymentDetails.json";
import FamilyUserPlansEN from "./locales/en/FamilyUserPlans.json";
import FamilyUserBlendedLearningEN from "./locales/en/FamilyUserBlendedLearning.json";
import FamilyUserPaymentDetailsEN from "./locales/en/FamilyUserPaymentDetails.json";
import StripeRedirectEN from "./locales/en/StripeRedirect.json";
import TrailsEN from "./locales/en/Trails.json";
import BusinessDataPrivacyTrailEN from "./locales/en/BusinessDataPrivacyTrail.json";
import BusinessPublicSpacesEN from "./locales/en/BusinessPublicSpaces.json";
import PointsHeaderEN from "./locales/en/PointsHeader.json";
import BusinessPointsEN from "./locales/en/BusinessPoints.json";
import BusinessCaseStudyQuestionEN from "./locales/en/BusinessCaseStudyQuestion.json";
import BusinessCaseStudiesResultsEN from "./locales/en/BusinessCaseStudiesResults.json";
import BusinessCourseEN from "./locales/en/BusinessCourse.json";
import BusinessCourseQuizEN from "./locales/en/BusinessCourseQuiz.json";
import ReportAnIssueEN from "./locales/en/ReportanIssue.json";
import BusinessCourseResultsEN from "./locales/en/BusinessCourseResults.json";
import BusinessPuzzleEN from "./locales/en/BusinessPuzzle.json";
import BusinessQuizChooseGuideEN from "./locales/en/BusinessQuizChooseGuide.json";
import BusinessQuizStartEN from "./locales/en/BusinessQuizStart.json";
import BusinessQuizEN from "./locales/en/BusinessQuiz.json";
import BusinessQuizResultsEN from "./locales/en/BusinessQuizResults.json";
import BusinessDataPrivacyTrailResultsEN from "./locales/en/BusinessDataPrivacyTrailResults.json";
import BusinessUnansweredQuestionsEN from "./locales/en/BusinessUnansweredQuestions.json";
import BusinessFactsEN from "./locales/en/BusinessFacts.json";
import BusinessFactsDetailsEN from "./locales/en/BusinessFactsDetails.json";
import WhatDidYouLearnEN from "./locales/en/WhatDidYouLearn.json";
import CertificateEN from "./locales/en/Certificate.json";
import WhatsOpenAiEN from "./locales/en/WhatsOpenAi.json";
import TransferJobEN from "./locales/en/TransferJob.json";
import SuggestFutureTrainingTopicsEN from "./locales/en/SuggestFutureTrainingTopics.json";
import ShareYourFeedbackEN from "./locales/en/ShareYourFeedback.json";
import RequestTrainingEN from "./locales/en/RequestTraining.json";
import RequestLegalAdviceEN from "./locales/en/RequestLegalAdvice.json";
import RequestLegalAdviceFormEN from "./locales/en/RequestLegalAdviceForm.json";
import ComplianceReportingDashboardEN from "./locales/en/ComplianceReportingDashboard.json";
import RequestOnlineTrainingEN from "./locales/en/RequestOnlineTraining.json";
import InformationSecurityEN from "./locales/en/InformationSecurity.json";
import ResponsibleAIEN from "./locales/en/ResponsibleAI.json";
import DataPrivacyEN from "./locales/en/DataPrivacy.json";
import AreaChartEN from "./locales/en/AreaChart.json";
import SweetAlertEN from "./locales/en/SweetAlert.json";
import DragAndDropEN from "./locales/en/DragAndDrop.json";
import validateForSignInEN from "./locales/en/Validate.json";
import commonEN from "./locales/en/commonEn.json";
import AIDashboardEN from "./locales/en/AIDashboard.json";
import AITrailEN from "./locales/en/AITrail.json";
import AIShareYourFeedbackEN from "./locales/en/AIShareYourFeedback.json";
import AdvantagesEN from "./locales/en/Advantages.json";
import AIUserPlansEN from "./locales/en/AIUserPlans.json";

// 💾 Load saved language or default to English
const savedLang = localStorage.getItem("lang") || "en";

const resources = {
    en: {
        index: indexMainpageEN,
        onlyme: OnlyMePageEN,
        myteam: MyTeamPageEN,
        header: headerEN,
        knowledgehubcategories: knowledgehubcategoriesEN,
        accessCourse: accessCourseEN,
        faq: faqEN,
        footer: footerEN,
        courseList: courseListEN,
        individualPricing: individualPricingEN,
        teams: teamsEN,
        CategoriesCard: CategoriesCardEN,
        ComparisonTable: ComparisonTableEN,
        CommunityAnnouncements: CommunityAnnouncementsEN,
        CommunityHomeBanner: CommunityHomeBannerEN,
        CommunitySidbar: CommunitySidbarEN,
        CommunitySidbarModal: CommunitySidbarModalEN,
        FaqQuestions: FaqQuestionsEN,
        CourseSidebar: CourseSidebarEN,
        FeaturedQuize1: FeaturedQuize1EN,
        FeaturedQuize2: FeaturedQuize2EN,
        Feedback: FeedbackEN,
        QuizResult: QuizResultEN,
        Signup: SignupEN,
        details: courseDetailsEN,
        StudentTestimonials: StudentTestimonialsEN,
        FeaturedDetails: FeaturedDetailsEN,
        Signin: SigninEN,
        BusinessOwnerDetails: BusinessOwnerDetailsEN,
        BusinessUserDetails: BusinessUserDetailsEN,
        BusinessSubscription: BusinessSubscriptionEN,
        BusinessPayment: BusinessPaymentEN,
        BusinessLandingPage: BusinessLandingPageEN,
        BussinessDashboardHome: BussinessDashboardHomeEN,
        Complete: CompleteEN,
        Complete2: Complete2EN,
        Subscription: SubscriptionEN,
        SelectSubscription: SelectSubscriptionEN,
        Payment: PaymentEN,
        PaymentProcessed: PaymentProcessedEN,
        CommunityHelp: CommunityHelpEN,
        CommunityHelpCenterTopic: CommunityHelpCenterTopicEN,
        BussinessProgress: BussinessProgressEN,
        AdminHeader: AdminHeaderEN,
        BusinessSidebar: BusinessSidebarEN,
        BusinessBookmarks: BusinessBookmarksEN,
        CourseCardCompornant: CourseCardCompornantEN,
        BusinessLeaderboard: BusinessLeaderboardEN,
        TopPerformers: TopPerformersEN,
        BusinessCourses: BusinessCoursesEN,
        BusinessQuizzes: BusinessQuizzesEN,
        BusinessLearningGroups: BusinessLearningGroupsEN,
        BusinessGroupView: BusinessGroupViewEN,
        BusinessAnalytics: BusinessAnalyticsEN,
        BusinessSettings: BusinessSettingsEN,
        BusinessCompliance: BusinessComplianceEN,
        EmployeeProfile: EmployeeProfileEN,
        Section1: Section1EN,
        Section2: Section2EN,
        CourseMandatory: CourseMandatoryEN,
        CoursesVoluntary: CoursesVoluntaryEN,
        EmployeesProgress: EmployeesProgressEN,
        EmployeeReport: EmployeeReportEN,
        BusinessFamily: BusinessFamilyEN,
        CustomerSidbar: CustomerSidbarEN,
        SliderHomeSec: SliderHomeSecEN,
        Family: FamilyEN,
        ChangePassword: ChangePasswordEN,
        EditProfile: EditProfileEN,
        UpdateAssociatedCode: UpdateAssociatedCodeEN,
        CustomerHome: CustomerHomeEN,
        CustomerHomeExplore: CustomerHomeExploreEN,
        CustomerMyProgress: CustomerMyProgressEN,
        CustomerBookmarks: CustomerBookmarksEN,
        CustomerLeaderboard: CustomerLeaderboardEN,
        CustomerCourses: CustomerCoursesEN,
        AssignCourseModal: AssignCourseModalEN,
        CustomerQuizzes: CustomerQuizzesEN,
        ContentHome: ContentHomeEN,
        ContentSidbar: ContentSidbarEN,
        ContentUpload: ContentUploadEN,
        FileDrop: FileDropEN,
        ContentPreview: ContentPreviewEN,
        ContentQuestions: ContentQuestionsEN,
        ContentMultifileQuizzes: ContentMultifileQuizzesEN,
        ContentCourses: ContentCoursesEN,
        ContentQuizzes: ContentQuizzesEN,
        CoursesExplore: CoursesExploreEN,
        CoursesHomeSec: CoursesHomeSecEN,
        CourseCard: CourseCardEN,
        CommunitySec: CommunitySecEN,
        CourseLevel: CourseLevelEN,
        GoldCourses: GoldCoursesEN,
        GoldCoursesHome: GoldCoursesHomeEN,
        SidbarCourses: SidbarCoursesEN,
        Compilance: CompilanceEN,
        CeoManager: CeoManagerEN,
        ComplianceOfficer: ComplianceOfficerEN,
        Dpos: DposEN,
        Employe: EmployeEN,
        SriLankaCourse: SriLankaCourseEN,
        CourseDetails: CourseDetailsEN,
        SrilLankaCourseQuize1: SrilLankaCourseQuize1EN,
        SrilLankaCourseQuize2: SrilLankaCourseQuize2EN,
        FeaturedGoldCourse: FeaturedGoldCourseEN,
        FeaturedGoldCourseDetails: FeaturedGoldCourseDetailsEN,
        FeaturedGoldCourseQuize1: FeaturedGoldCourseQuize1EN,
        FeaturedGoldCourseQuize2: FeaturedGoldCourseQuize2EN,
        BulkUpload: BulkUploadEN,
        UploadFile: UploadFileEN,
        PreviewTable: PreviewTableEN,
        Import: ImportEN,
        AssignCourse: AssignCourseEN,
        SelectCourse: SelectCourseEN,
        SetCourse: SetCourseEN,
        Otp: OtpEN,
        KidsAgeConfirm: KidsAgeConfirmEN,
        ParentDetail: ParentDetailEN,
        ParentApproval: ParentApprovalEN,
        RejectKid: RejectKidEN,
        Imprint: ImprintEN,
        TermsAndCondition: TermsAndConditionEN,
        TestEnvironmentWelcome: TestEnvironmentWelcomeEN,
        BusinessUserPlans: BusinessUserPlansEN,
        BusinessUserSupportPlans: BusinessUserSupportPlansEN,
        BusinessUserSharedCourses: BusinessUserSharedCoursesEN,
        BusinessUserPayment: BusinessUserPaymentEN,
        BusinessSetting: BusinessSettingEN,
        BusinessUserCourseTrail: BusinessUserCourseTrailEN,
        BusinessUserIndividualizedCourses: BusinessUserIndividualizedCoursesEN,
        BusinessUserBlendedLearning: BusinessUserBlendedLearningEN,
        PaymentDetails: PaymentDetailsEN,
        FamilyUserPlans: FamilyUserPlansEN,
        FamilyUserBlendedLearning: FamilyUserBlendedLearningEN,
        FamilyUserPaymentDetails: FamilyUserPaymentDetailsEN,
        StripeRedirect: StripeRedirectEN,
        Trails: TrailsEN,
        BusinessDataPrivacyTrail: BusinessDataPrivacyTrailEN,
        BusinessPublicSpaces: BusinessPublicSpacesEN,
        PointsHeader: PointsHeaderEN,
        BusinessPoints: BusinessPointsEN,
        BusinessCaseStudyQuestion: BusinessCaseStudyQuestionEN,
        BusinessCaseStudiesResults: BusinessCaseStudiesResultsEN,
        BusinessCourse: BusinessCourseEN,
        BusinessCourseQuiz: BusinessCourseQuizEN,
        ReportAnIssue: ReportAnIssueEN,
        BusinessCourseResults: BusinessCourseResultsEN,
        BusinessPuzzle: BusinessPuzzleEN,
        BusinessQuizChooseGuide: BusinessQuizChooseGuideEN,
        BusinessQuizStart: BusinessQuizStartEN,
        BusinessQuiz: BusinessQuizEN,
        BusinessQuizResults: BusinessQuizResultsEN,
        BusinessDataPrivacyTrailResults: BusinessDataPrivacyTrailResultsEN,
        BusinessUnansweredQuestions: BusinessUnansweredQuestionsEN,
        BusinessFacts: BusinessFactsEN,
        BusinessFactsDetails: BusinessFactsDetailsEN,
        WhatDidYouLearn: WhatDidYouLearnEN,
        Certificate: CertificateEN,
        WhatsOpenAi: WhatsOpenAiEN,
        TransferJob: TransferJobEN,
        SuggestFutureTrainingTopics: SuggestFutureTrainingTopicsEN,
        ShareYourFeedback: ShareYourFeedbackEN,
        RequestTraining: RequestTrainingEN,
        RequestLegalAdvice: RequestLegalAdviceEN,
        RequestLegalAdviceForm: RequestLegalAdviceFormEN,
        ComplianceReportingDashboard: ComplianceReportingDashboardEN,
        AreaChart: AreaChartEN,
        RequestOnlineTraining: RequestOnlineTrainingEN,
        InformationSecurity: InformationSecurityEN,
        ResponsibleAI: ResponsibleAIEN,
        DataPrivacy: DataPrivacyEN,
        SweetAlert: SweetAlertEN,
        DragAndDrop: DragAndDropEN,
        validateForSignIn: validateForSignInEN,
        common: commonEN,
        AIDashboard: AIDashboardEN,
        AITrail: AITrailEN,
        AIShareYourFeedback: AIShareYourFeedbackEN,
        Advantages: AdvantagesEN,
        AIUserPlans: AIUserPlansEN
    },
    de: {
        index: indexDE,
        onlyme: OnlyMeDE,
        myteam: MyTeamDE,
        header: HeaderDE,
        knowledgehubcategories: KnowledgeHubCategoriesDE,
        accessCourse: AccessCourseDE,
        faq: FaqDE,
        footer: FooterDE,
        courseList: CourseListDE,
        individualPricing: IndividualPricingDE,
        teams: TeamsDE,
        CategoriesCard: CategoriesCardDE,
        ComparisonTable: ComparisonTableDE,
        CommunityAnnouncements: CommunityAnnouncementsDE,
        CommunityHomeBanner: CommunityHomeBannerDE,
        CommunitySidbar: CommunitySidbarDE,
        CommunitySidbarModal: CommunitySidbarModalDE,
        FaqQuestions: FaqQuestionsDE,
        CourseSidebar: CourseSidebarDE,
        FeaturedQuize1: FeaturedQuize1DE,
        FeaturedQuize2: FeaturedQuize2DE,
        Feedback: FeedbackDE,
        QuizResult: QuizeResultsDE,
        Signup: SignUpDE,
        StudentTestimonials: StudentTestimonialsDE,
        FeaturedDetails: FeaturedDetailsDE,
        Signin: SignInDE,
        BusinessOwnerDetails: BusinessUserDetailsDE,
        BusinessUserDetails: BusinessUserDetailsDE,
        BusinessSubscription: BusinessSubscriptionDE,
        BusinessPayment: BusinessPaymentDE,
        BusinessLandingPage: BusinessLandingPageDE,
        BussinessDashboardHome: BusinessDashbaordHomeDE,
        Complete: CompleteDE,
        Complete2: Complete2DE,
        Subscription: SubscriptionDE,
        Payment: PaymentDE,
        CommunityHelp: CommunityHelpDE,
        CommunityHelpCenterTopic: CommunityHelpCenterTopicDE,
        BussinessProgress: BusinessProgressDE,
        AdminHeader: AdminHeaderDE,
        BusinessSidebar: BusinessSidebarDE,
        BusinessBookmarks: BusinessBookmarksDE,
        CourseCardCompornant: CourseCardCompornantDE,
        BusinessLeaderboard: BusinessLeaderboardDE,
        TopPerformers: TopPerformersDE,
        BusinessCourses: BusinessCoursesDE,
        BusinessQuizzes: BusinessQuizzesDE,
        BusinessLearningGroups: BusinessLearningGroupsDE,
        BusinessGroupView: BusinessGroupViewDE,
        BusinessAnalytics: BusinessAnalyticsDE,
        BusinessSetting: BusinessSettingDE,
        BusinessCompliance: BusinessComplianceDE,
        EmployeeProfile: EmployeeProfileDE,
        Section1: Section1DE,
        Section2: Section2DE,
        CourseMandatory: CourseMandatoryDE,
        CoursesVoluntary: CoursesVoluntaryDE,
        EmployeesProgress: EmployeesProgressDE,
        EmployeeReport: EmployeeReportDE,
        BusinessFamily: BusinessFamilyDE,
        CustomerSidbar: CustomerSidbarDE,
        SliderHomeSec: SliderHomeSecDE,
        Family: FamilyDE,
        ChangePassword: ChangePasswordDE,
        EditProfile: EditProfileDE,
        UpdateAssociatedCode: UpdateAssociatedCodeDE,
        CustomerHome: CustomerHomeDE,
        CustomerHomeExplore: CustomerHomeExploreDE,
        CustomerMyProgress: CustomerMyProgressDE,
        CustomerBookmarks: CustomerBookmarksDE,
        CustomerLeaderboard: CustomerLeaderboardDE,
        CustomerCourses: CustomerCoursesDE,
        AssignCourseModal: AssignCourseModalDE,
        CustomerQuizzes: CustomerQuizzesDE,
        ContentHome: ContentHomeDE,
        ContentSidbar: ContentSidbarDE,
        ContentUpload: ContentUploadDE,
        FileDrop: FileDropDE,
        ContentPreview: ContentPreviewDE,
        ContentQuestions: ContentQuestionsDE,
        ContentMultifileQuizzes: ContentMultifileQuizzesDE,
        ContentCourses: ContentCoursesDE,
        ContentQuizzes: ContentQuizzesDE,
        CoursesExplore: CoursesExploreDE,
        CoursesHomeSec: CoursesHomeSecDE,
        CourseCard: CourseCardDE,
        CommunitySec: CommunitySecDE,
        CourseLevel: CourseLevelDE,
        GoldCourses: GoldCoursesDE,
        GoldCoursesHome: GoldCoursesHomeDE,
        SidbarCourses: SidbarCoursesDE,
        Compilance: CompilanceDE,
        CeoManager: CeoManagerDE,
        ComplianceOfficer: ComplianceOfficerDE,
        Dpos: DposDE,
        Employe: EmployeDE,
        SriLankaCourse: SriLankaCourseDE,
        CourseDetails: CourseDetailsDE,
        SrilLankaCourseQuize1: SrilLankaCourseQuize1DE,
        SrilLankaCourseQuize2: SrilLankaCourseQuize2DE,
        FeaturedGoldCourse: FeaturedGoldCourseDE,
        FeaturedGoldCourseDetails: FeaturedGoldCourseDetailsDE,
        AssignCourse: AssignCourseDE,
        BulkUpload: BulkUploadDE,
        BusinessUserBlendedLearning: BusinessUserBlendedLearningDE,
        BusinessUserCourseTrail: BusinessUserCourseTrailDE,
        BusinessUserIndividualizedCourses: BusinessUserIndividualizedCoursesDE,
        BusinessUserPayment: BusinessUserPaymentDE,
        BusinessUserPlans: BusinessUserPlansDE,
        BusinessUserSharedCourses: BusinessUserSharedCoursesDE,
        BusinessUserSupportPlans: BusinessUserSupportPlansDE,
        FeaturedGoldCourseQuize1: FeaturedGoldCourseQuize1DE,
        FeaturedGoldCourseQuize2: FeaturedGoldCourseQuize2DE,
        Import: ImportDE,
        Imprint: ImprintDE,
        KidsAgeConfirm: KidsAgeConfirmDE,
        Otp: OtpDE,
        ParentApproval: ParentApprovalDE,
        ParentDetail: ParentDetailDE,
        PaymentDetails: PaymentDetailsDE,
        PreviewTable: PreviewTableDE,
        RejectKid: RejectKidDE,
        SelectCourse: SelectCourseDE,
        SetCourse: SetCourseDE,
        TermsAndCondition: TermsAndConditionDE,
        TestEnvironmentWelcome: TestEnvironmentWelcomeDE,
        UploadFile: UploadFileDE,
        InformationSecurity: InformationSecurityDE,
        PointsHeader: PointsHeaderDE,
        ReportAnIssue: ReportanIssueDE,
        RequestLegalAdvice: RequestLegalAdviceDE,
        RequestLegalAdviceForm: RequestLegalAdviceFormDE,
        RequestOnlineTraining: RequestOnlineTrainingDE,
        RequestTraining: RequestTrainingDE,
        ResponsibleAI: ResponsibleAIDE,
        ShareYourFeedback: ShareYourFeedbackDE,
        StripeRedirect: StripeRedirectDE,
        SuggestFutureTrainingTopics: SuggestFutureTrainingTopicsDE,
        Trails: TrailsDE,
        TransferJob: TransferJobDE,
        WhatDidYouLearn: WhatDidYouLearnDE,
        WhatsOpenAi: WhatsOpenAiDE,
        BusinessCaseStudiesResults: BusinessCaseStudiesResultsDE,
        BusinessCaseStudyQuestion: BusinessCaseStudyQuestionDE,
        BusinessCourse: BusinessCourseDE,
        BusinessCourseQuiz: BusinessCourseQuizDE,
        BusinessCourseResults: BusinessCourseResultsDE,
        BusinessDataPrivacyTrail: BusinessDataPrivacyTrailDE,
        SelectSubscription: SelectSubscriptionDE,
        BusinessDataPrivacyTrailResults: BusinessDataPrivacyTrailResultsDE,
        BusinessFacts: BusinessFactsDE,
        BusinessFactsDetails: BusinessFactsDetailsDE,
        BusinessPoints: BusinessPointsDE,
        BusinessPublicSpaces: BusinessPublicSpacesDE,
        PaymentProcessed: PaymentProcessedDE,
        BusinessPuzzle: BusinessPuzzleDE,
        BusinessQuiz: BusinessQuizDE,
        BusinessQuizChooseGuide: BusinessQuizChooseGuideDE,
        BusinessQuizResults: BusinessQuizResultsDE,
        BusinessQuizStart: BusinessQuizStartDE,
        BusinessUnansweredQuestions: BusinessUnansweredQuestionsDE,
        Certificate: CertificateDE,
        ComplianceReportingDashboard: ComplianceReportingDashboardDE,
        DataPrivacy: DataPrivacyDE,
        FamilyUserBlendedLearning: FamilyUserBlendedLearningDE,
        AreaChart: AreaChartDE,
        FamilyUserPaymentDetails: FamilyUserPaymentDetailsDE,
        FamilyUserPlans: FamilyUserPlansDE,
        QuizResult: QuizResultDE,
        SweetAlert: SweetAlertDE,
        DragAndDrop: DragAndDropDE,
        validateForSignIn: validateForSignInDE,
        common: commonDE,
        AIDashboard: AIDashboardDE,
        AITrail: AITrailDE,
        AIShareYourFeedback: AIShareYourFeedbackDE,
        Advantages: AdvantagesDE,
        AIUserPlans: AIUserPlansDE
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: savedLang, // default language
    fallbackLng: "en",
    // eslint-disable-next-line no-sparse-arrays
    ns: [
        "index",
        "onlyme",
        "myteam",
        "header",
        "knowledgehubcategories",
        "accessCourse",
        "faq",
        "footer",
        "courseList",
        "individualPricing",
        "teams",
        ,
        "CategoriesCard",
        "ComparisonTable",
        "CommunityAnnouncements",
        "CommunityHomeBanner",
        "CommunitySidbar",
        "CommunitySidbarModal",
        "FaqQuestions",
        "CourseSidebar",
        "FeaturedQuize1",
        "FeaturedQuize2",
        "Feedback",
        "QuizResult",
        "Signup",
        "details",
        "StudentTestimonials",
        "FeaturedDetails",
        "about",
        "Signin",
        "BusinessOwnerDetails",
        "BusinessUserDetails",
        "BusinessSubscription",
        "BusinessPayment",
        "BusinessLandingPage",
        "BussinessDashboardHome",
        "Complete",
        "Complete2",
        "Subscription",
        "SelectSubscription",
        "Payment",
        "PaymentProcessed",
        "CommunityHelp",
        "CommunityHelpCenterTopic",
        "BussinessProgress",
        "AdminHeader",
        "BusinessSidebar",
        "BusinessBookmarks",
        "CourseCardCompornant",
        "BusinessLeaderboard",
        "TopPerformers",
        "BusinessCourses",
        "BusinessQuizzes",
        "BusinessLearningGroups",
        "BusinessGroupView",
        "BusinessAnalytics",
        "BusinessCompliance",
        "EmployeeProfile",
        "Section1",
        "Section2",
        "CourseMandatory",
        "CoursesVoluntary",
        "EmployeesProgress",
        "EmployeeReport",
        "BusinessFamily",
        "CustomerSidbar",
        "SliderHomeSec",
        "Family",
        "ChangePassword",
        "EditProfile",
        "UpdateAssociatedCode",
        "CustomerHome",
        "CustomerHomeExplore",
        "CustomerMyProgress",
        "CustomerBookmarks",
        "CustomerLeaderboard",
        "CustomerCourses",
        "AssignCourseModal",
        "CustomerQuizzes",
        "ContentHome",
        "ContentSidbar",
        "ContentUpload",
        "FileDrop",
        "ContentPreview",
        "ContentQuestions",
        "ContentMultifileQuizzes",
        "ContentCourses",
        "ContentQuizzes",
        "CoursesExplore",
        "CoursesHomeSec",
        "CourseCard",
        "CommunitySec",
        " CourseLevel",
        "GoldCourses",
        "GoldCoursesHome",
        "SidbarCourses",
        "Compilance",
        "CeoManager",
        "ComplianceOfficer",
        "Dpos",
        "Employe",
        "SriLankaCourse",
        "CourseDetails",
        "SrilLankaCourseQuize1",
        "SrilLankaCourseQuize2",
        "FeaturedGoldCourse",
        "FeaturedGoldCourseDetails",
        "FeaturedGoldCourseQuize1",
        "FeaturedGoldCourseQuize2",
        "BulkUpload",
        "UploadFile",
        "PreviewTable",
        "Import",
        "AssignCourse",
        "SelectCourse",
        "SetCourse",
        "Otp",
        "KidsAgeConfirm",
        "ParentDetail",
        "ParentApproval",
        "RejectKid",
        "Imprint",
        "TermsAndCondition",
        "TestEnvironmentWelcome",
        "BusinessUserPlans",
        "BusinessUserSupportPlans",
        "BusinessUserSharedCourses",
        "BusinessUserPayment",
        "BusinessSetting",
        "BusinessUserCourseTrail",
        "BusinessUserIndividualizedCourses",
        "BusinessUserBlendedLearning",
        "PaymentDetails",
        "FamilyUserPlans",
        "FamilyUserBlendedLearning",
        "FamilyUserPaymentDetails",
        "StripeRedirect",
        "Trails",
        "BusinessDataPrivacyTrail",
        "BusinessPublicSpaces",
        "PointsHeader",
        "BusinessPoints",
        "BusinessCaseStudyQuestion",
        "BusinessCaseStudiesResults",
        "BusinessCourse",
        "BusinessCourseQuiz",
        "ReportAnIssue",
        "BusinessCourseResults",
        "BusinessPuzzle",
        "BusinessQuizChooseGuide",
        "BusinessQuizStart",
        "BusinessQuiz",
        "BusinessQuizResults",
        "BusinessDataPrivacyTrailResults",
        "BusinessUnansweredQuestions",
        "BusinessFacts",
        "BusinessFactsDetails",
        "WhatDidYouLearn",
        "Certificate",
        "WhatsOpenAi",
        "TransferJob",
        "SuggestFutureTrainingTopics",
        "ShareYourFeedback",
        "RequestTraining",
        "RequestLegalAdvice",
        "RequestLegalAdviceForm",
        "ComplianceReportingDashboard",
        "RequestOnlineTraining",
        "InformationSecurity",
        "ResponsibleAI",
        "DataPrivacy",
        "SweetAlert",
        "DragAndDrop",
        "validateForSignIn",
        "common",
        "AIDashboard",
        "AITrail",
        "AIShareYourFeedback",
        "Advantages",
        "AIUserPlans",
    ], // namespaces,""
    defaultNS: "index", // default namespace
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
